import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { default as MCheckbox } from 'material-ui/Checkbox';
import { RowDivision, DivisionLabel, MultiCheckbox } from '../shared/styled-components';
import styles from '../shared/styles';
import {
  reorderInArray, 
  createOrderedBundleSoundcasts,
} from '../managed/sorting_utils';
import {
  SoundcastSelectRow,
  SoundcastSelectColumn,
  SoundcastDragColumn,
} from '../managed/styled';
import { LoadingWrapper } from '../../../../styles/styled';
import Loading from '../../../../components/Loading';

const getDraggableListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
});

const getDraggableItemStyle = (isDragging, draggableStyle) => ({
  // background: isDragging ? "lightgreen" : "grey",
  ...draggableStyle,
});

class MultiSelectDraggable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectAll: false,
      selectedItems: props.selectedItems,
      soundcasts: [],
      loading: true,
    };

    this.onDragEnd = this.onDragEnd.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this.onSelectItem = this.onSelectItem.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEqual(prevState.selectedItems, nextProps.selectedItems)) {
      return({
        selectedItems: nextProps.selectedItems,
      });
    }

    const { soundcastId, order = {}, editmode = true } = nextProps;
    const { dashboardBundleSoundcastIds: orderedInBundles = {} } = order;
    if (editmode && (isEmpty(orderedInBundles) || !Object.keys(orderedInBundles).includes(soundcastId))) {
      nextProps.onFetchOrder({
        soundcastId,
      });
      return {
        loading: true,
      };
    }

    const soundcasts = createOrderedBundleSoundcasts(nextProps, prevState);

    return {
      loading: false,
      soundcasts,
    };
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    // dropped in the same place
    if (result.source.index === result.destination.index) {
      return;
    }

    const soundcasts = reorderInArray(
      this.state.soundcasts,
      result.source.index,
      result.destination.index
    );

    this.setState({
      soundcasts,
    });

    this.props.onDragEnd({  
      soundcastId: this.props.soundcastId,
      soundcasts,
      selectedItems: this.state.selectedItems,
      isTemp: true,
    });
  }

  onSelectAll(e, isChecked) {
    const { items } = this.props;
    const selectedItems = (isChecked) ? [ ...items ] : [];
    this.setState({
      selectAll: isChecked,
      selectedItems,
    }, () => {
      // update parent props
      this.props.onSelected(selectedItems);
    });
  }

  onSelectItem(item) {
    return (e, isChecked) => {
      let { selectAll, selectedItems } = this.state;
      if (isChecked) {
        selectedItems.push({...item});
      } else {
        // look for the already selectedItems index and remove it
        selectedItems = selectedItems.filter(sitem => !isEqual(sitem.id, item.id));
      }

      // if selectAll was selected
      // turn it off once a user
      // selected items manually
      this.setState({
        selectAll: (selectAll) ? false : selectAll,
        selectedItems,
      }, () => {
        // update parent props
        this.props.onSelected(selectedItems);
      });
    };
  }

  isItemSelected(item) {
    const { selectedItems } = this.state;

    if (isEmpty(item)) {
      return false;
    }

    const exist = selectedItems.find(sitem => isEqual(sitem.id, item.id));
    return (exist) ? true : false;
  }

  isAllItemsSelected() {
    const { items } = this.props;
    const { selectedItems } = this.state;
    return isEqual(items.length, selectedItems.length);
  }

  render() {
    const { label, required } = this.props;
    const { soundcasts, selectAll, loading = true } = this.state;

    const requiredRender = (required) ? (
      <span style={styles.inputLabelRequire}>*</span>
    ) : null;

    return (
      <RowDivision className="row">
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>
            {label} {requiredRender}
          </DivisionLabel>
          <MultiCheckbox>
            <div className="all-checkbox">
              <MCheckbox
                checked={selectAll || this.isAllItemsSelected()}
                disabled={isEmpty(soundcasts)}
                label="Select all"
                onCheck={this.onSelectAll}
                labelStyle={{
                  fontSize: '1.6rem',
                  fontWeight: 'normal',
                }}
                iconStyle={{
                  width: 25,
                  height: 25,
                  fill: '#ff8f53',
                }}
              />
            </div>
            <div className="child-checkboxes">
            {loading &&
              <LoadingWrapper height="30">
                <Loading text="Loading soundcasts, please wait" />
              </LoadingWrapper>
            } 
            {!loading &&
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getDraggableListStyle(snapshot.isDraggingOver)}>
                      {soundcasts.map((soundcast, index) => {
                        return (
                          <Draggable
                          key={`soundcast-item-${soundcast.id}`}
                          draggableId={`soundcast-item-${soundcast.id}`}
                          index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getDraggableItemStyle(snapshot.isDragging, provided.draggableProps.style)}>

                              <SoundcastSelectRow className="row" alignItems="center">
                                <SoundcastSelectColumn className="checkbox-wrapper">
                                  <MCheckbox
                                    key={`soundcast-item-${index}`}
                                    checked={this.isItemSelected(soundcast)}
                                    onCheck={this.onSelectItem(soundcast)}
                                    iconStyle={{
                                      width: 25,
                                      height: 25,
                                      fill: '#ff8f53',
                                    }}
                                  />
                                </SoundcastSelectColumn>
                                <SoundcastSelectColumn>
                                  {!soundcast.published && '[draft]'} {soundcast.title}
                                </SoundcastSelectColumn>
                                <SoundcastDragColumn>
                                  <i className="material-icons">drag_handle</i>
                                </SoundcastDragColumn>
                              </SoundcastSelectRow>
                            </div>
                          )}
                        </Draggable>
                        );

                      })}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            } 
            </div>
          </MultiCheckbox>
        </div>
      </RowDivision>
    );
  }
}

MultiSelectDraggable.propTypes = {
  soundcastId: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  items: PropTypes.array,
  selectedItems: PropTypes.array,
  onSelected: PropTypes.func,
  onDragEnd: PropTypes.func,
  order: PropTypes.object,
  editmode: PropTypes.bool,
};

MultiSelectDraggable.defaultProps = {
  soundcastId: '',
  label: '',
  required: false,
  items: [],
  selectedItems: [],
  onSelected: () => {},
  onDragEnd: () => {},
  onFetchOrder: () => {},
  order: {},
  editmode: true,
};

export default MultiSelectDraggable;
